package com.neurobs.ccabserver.subjectsessionview.components.sessionselection.components

import com.neurobs.ccab.SessionDisplayData
import com.neurobs.ccabserver.subjectsessionview.states.{SessionSelectionStateGenerator, UserState}
import com.neurobs.js.util.StringUtilities.dateTimeString
import com.neurobs.react.ReactUtil
import com.neurobs.react.semanticui.UiListFactory
import slinky.core.FunctionalComponent
import slinky.core.annotations.react

import scala.scalajs.js

@react
object SessionSelectionList {
  case class Props(sessions: List[SessionDisplayData])
  val component = FunctionalComponent[Props] { props =>

    val listStyle = Seq[(String, js.Any)](("borderTop", "2px solid #2185d0"), ("paddingTop", "5px"))

    UiListFactory.List(
      props.sessions.map(SessionSelectionListItem(_))
    )(("selection", listStyle))
  }
}

@react
object SessionSelectionListItem {
  case class Props(session: SessionDisplayData)
  val component = FunctionalComponent[Props] { props =>

    val userState = UserState.accessState
    val sessionSelectionState = SessionSelectionStateGenerator.accessState

    def isSiteAdmin = userState.userData.isSiteAdmin

    def handleClick = () => {
      sessionSelectionState.selectedSessionState.setValue(Some(props.session))
    }

    def dateTime = {
      dateTimeString(props.session.session.session.startTime) + (if (isSiteAdmin) s" (${props.session.session.session.sessionId})" else "")
    }

    UiListFactory.ListItem(
      handleClick = handleClick
    )(
      if (isSiteAdmin) {
        UiListFactory.ListContent(
          UiListFactory.ListHeader(props.session.session.session.subjectGuid.toString),
          dateTime
        )
      } else {
        UiListFactory.ListContent(
          UiListFactory.ListHeader(dateTime)
        )
      }
    )
  }
}